module.exports = __webpack_public_path__ + "img/zanwukecheng.100cd821.png";